import { Component, inject } from '@angular/core';
import { BaseModalComponent } from "../../../../../../core/components/modals/base-modal/base-modal.component";
import { TelegramChatHistoryStateService } from "../../../../../../core/services/telegram-chat-history-state.service";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ChatHistoryParams } from "../../../../../../core/types/chat-history.types";
import { MatButton } from "@angular/material/button";
import { telegramChatHistoryModalName } from "./configs/telegram-chat-history-config";

@Component({
  selector: 'app-telegram-chat-history',
  imports: [
    BaseModalComponent,
    MatButton
  ],
  templateUrl: './telegram-chat-history.component.html',
  styleUrl: './telegram-chat-history.component.scss'
})
export class TelegramChatHistoryComponent extends BaseModalComponent {
  private telegramChatHistoryStateService: TelegramChatHistoryStateService = inject(TelegramChatHistoryStateService);
  private telegramChatHistoryDialogData = inject<number>(MAT_DIALOG_DATA);

  public telegramChatHistoryParams: ChatHistoryParams | null = null;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(telegramChatHistoryModalName);
    this.telegramChatHistoryParams = this.telegramChatHistoryStateService.getTelegramChatHistoryById(this.telegramChatHistoryDialogData);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(telegramChatHistoryModalName);
  }

  public getData(): string {
    return this.telegramChatHistoryParams?.chatStartDate ? this.utilityService.formatArrayToRussianDateTime(this.telegramChatHistoryParams.chatStartDate) : '';
  }
}
